import OnEnterMixin from '@/components/mixins/onenter-mixin'
import { mapState } from 'pinia'
import { tagsStore } from '../../../pinia/stores/tagsStore'

export default {
  name: 'tags',
  inject: [
    '$currentUser',
    '$utils'
  ],
  components: {
  },
  props: {
    tagsProp: {
      type: Array,
      default () { return [] }
    },
    accessorComponentProp: {
      type: String,
      default () { return 'mediaMenu' }
    },
    tagsSummaryProp: {
      type: Array,
      default () { return [] }
    },
    selectedTagsFromSliderProp: {
      type: Array,
      default () { return [] }
    },
    disabledEditTagItemsProp: {
      type: Array,
      default () { return [] }
    },
    elClassProp: {
      default () { return null }
    },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState(tagsStore, ['tagSliderTagCombinations']),
    storeOnLoadTagsFromSlider () {
      const onLoadTagSlider = this.tagSliderTagCombinations
      let res = onLoadTagSlider

      // Make sure it's a flat array
      if ((typeof onLoadTagSlider === 'object' && !Array.isArray(onLoadTagSlider) && onLoadTagSlider !== null)) {
        res = []
        for (const tagType in onLoadTagSlider) {
          for (const arrIndx in onLoadTagSlider[tagType]) {
            const tag = onLoadTagSlider[tagType][arrIndx]
            tag.type = tagType
            res.push(tag)
          }
        }
      }

      return res
    }
  },
  watch: {
    tagsProp: {
      handler (newValue) {
        this.setDefaultData(newValue, 'tagsPropChanged')
      },
      deep: true
    },
    accessorComponentProp (newVal) {
      this.accessorComponent = newVal
      this.handleTagsActionPermission()
    },
    tagsSummaryProp: {
      handler (newVal) {
        this.tagsSummary = newVal
        this.handleNewTagOptions()
      },
      deep: true
    },
    selectedTagsFromSliderProp: {
      handler (newVal) {
        this.selectedTagsFromSlider = newVal
      },
      deep: true
    },
    disabledEditTagItemsProp: {
      handler (newVal) {
        this.disabledEditTagItems = newVal
      },
      deep: true
    }
  },
  mixins: [OnEnterMixin],
  data () {
    return {
      accessorComponent: this.accessorComponentProp,
      tags: this.tagsProp,
      tagItemColorOptions: ['#52f9e5', '#4bccdb', '#628bc8', '#7471c5', '#9443c2'],
      inputVisible: false,
      isNewInputTagVisible: false,
      inputValue: '',
      inputTagValueBeforeChanged: '',
      normalTagMaxCharLength: 32,
      configTagMaxCharLength: 128,
      newTagSelectedValue: '',
      hoveredTagItem: null,
      maxNewTag: 50,
      selectedTagItem: {
        index: null,
        origVal: null,
        newVal: null,
        createNewTag: false
      },
      enableCreateTags: true,
      enableEditTags: true,
      enableDeleteTags: true,
      tagsSummary: this.tagsSummaryProp,
      newTagOptions: [],
      selectedTagsFromSlider: this.selectedTagsFromSliderProp,
      addNewTagAsDropdown: false,
      disabledEditTagItems: this.disabledEditTagItemsProp,
      forceToHideNewButton: false,
      accessorComponents: {
        mediaMenu: 'mediaMenu',
        projectTemplateMenu: 'projectTemplateMenu',
        templateSets: 'templateSets',
        playerNormalTagsMenuItem: 'playerNormalTagsMenuItem',
        playerLEDTagsMenuItem: 'playerLEDTagsMenuItem',
        monitoringNormalTagsInfo: 'monitoringNormalTagsInfo',
        monitoringLEDTagsInfo: 'monitoringLEDTagsInfo'
      }
    }
  },
  methods: {
    handleChanges () {
      this.$store.dispatch('runAutoSave', this.playerSelection)
    },
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('tags-change', { action, payload: { data, accessorComponent: this.accessorComponent } })
      }
    },
    setDefaultData (tagsSrc, type) {
      const newTags = this.$utils.clone(tagsSrc)

      // Keep the selection and latest value. Selection will reset if tags prop or tags slider data will change
      if (type === 'tagsPropChanged' && (this.selectedTagItem.index !== null && !this.selectedTagItem.createNewTag)) {
        const selectedTagItem = this.$utils.clone(this.selectedTagItem)
        const getTagIndex = newTags.findIndex((tag) => { return tag === selectedTagItem.origVal })
        if (getTagIndex >= 0) newTags[getTagIndex] = selectedTagItem.newVal
      } else {
        this.resetTagsSelection()
      }

      this.tags = this.filterTagsItemForUI(newTags)
      this.handleTagsActionPermission()
      this.handleNewTagInputElBlur()
      this.handleNewTagOptions()

      this.hoveredTagItem = null
      this.$store.dispatch('setOnLoadTags', this.tags)
      this.$store.dispatch('resetUpdatedTags')
      this.handleForceToHideNewButton()
    },
    querySearch (queryString, cb) {
      let links = this.$utils.clone(this.tagsSummary)
      const updatedTags = this.$utils.clone(this.tags)

      // Remove All tag item for suggestion
      const existFromList = (tagItem) => { return updatedTags.find((t) => { return t.value === tagItem.value }) }
      links = links.filter((item) => {
        return item.value && item.value !== '_toSeeAllData' && !existFromList(item)
      })

      let results = queryString ? links.filter(this.createFilter(queryString)) : links

      results = this.$utils.sortTags({ tags: results }) // Sort tags Alphabetically

      cb(results) // call callback function to return suggestions
    },
    createFilter (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleTagsActionPermission () {
      // Tags used for media
      if ([this.accessorComponents.mediaMenu, this.accessorComponents.projectTemplateMenu].indexOf(this.accessorComponent) >= 0) {
        if (!this.$currentUser.getRights().userCreate.editTags) {
          this.enableCreateTags = false
          this.enableEditTags = false
          this.enableDeleteTags = false
        }

        if (!this.$currentUser.hasGroupUserAdmin() && this.$currentUser.hasGroupUserCreateLock()) {
          this.enableEditTags = false
        }
      }

      // Template sets tag
      if ([this.accessorComponents.templateSets].indexOf(this.accessorComponent) >= 0) {
        if (!this.$currentUser.getRights().userCreate.editTags || this.$currentUser.getUserTags().length) {
          this.enableCreateTags = false
          this.enableEditTags = false
          this.enableDeleteTags = false
        }

        if (!this.$currentUser.hasGroupUserAdmin() && this.$currentUser.hasGroupUserCreateLock()) {
          this.enableEditTags = false
        }
      }

      // Tags used for player
      if ([this.accessorComponents.playerNormalTagsMenuItem, this.accessorComponents.playerLEDTagsMenuItem].indexOf(this.accessorComponent) >= 0 && !this.$currentUser.getRights().userPlayer.editPlayer) {
        this.enableCreateTags = false
        this.enableEditTags = false
        this.enableDeleteTags = false
      }

      // Tags used for monitoring page
      if ([this.accessorComponents.monitoringNormalTagsInfo, this.accessorComponents.monitoringLEDTagsInfo].indexOf(this.accessorComponent) >= 0) {
        this.enableCreateTags = false
        this.enableEditTags = false
        this.enableDeleteTags = false
      }

      // Enable Add as dropdown
      this.addNewTagAsDropdown = false
      if (!this.$currentUser.hasGroupUserAdmin() && this.$currentUser.hasGroupUserCreateLock() && [this.accessorComponents.mediaMenu, this.accessorComponents.projectTemplateMenu, this.accessorComponents.templateSets].indexOf(this.accessorComponent) >= 0) {
        this.addNewTagAsDropdown = true
      } else if (this.$currentUser.getRights().userPlayer.editPlayer && [this.accessorComponents.playerLEDTagsMenuItem].indexOf(this.accessorComponent) >= 0) {
        this.addNewTagAsDropdown = true
      }
    },
    handleRemoveIconClick (tagIndx, tagValue) {
      if (this.disabledEditTagItems.indexOf(tagValue) >= 0) return

      this.tags.splice(tagIndx, 1)
      this.tags = this.filterTagsItemForUI(this.tags)
      this.emitEvent('TAG_REMOVED', { tagRemoved: tagValue, tags: this.filterTagsItemForBackend(this.tags) })
      this.$store.dispatch('updatedTags', { lastAction: 'deleted', tagOldVal: tagValue, tags: this.filterTagsItemForBackend(this.tags), component: this.accessorComponent })
      this.handleNewTagOptions()
      this.handleForceToHideNewButton()
    },
    handleForceToHideNewButton () {
      this.forceToHideNewButton = false

      if (this.tags.length && (this.accessorComponent === this.accessorComponents.playerLEDTagsMenuItem)) {
        this.forceToHideNewButton = true
      } else if (this.$currentUser.getUserTags().length && ([this.accessorComponents.mediaMenu, this.accessorComponents.templateSets].indexOf(this.accessorComponent) >= 0)) {
        this.forceToHideNewButton = true
      } else if (this.tags.length && (this.accessorComponent === this.accessorComponents.monitoringPage)) {
        this.forceToHideNewButton = true
      }
    },
    handleShowNewTagInput () {
      this.isNewInputTagVisible = true
      this.$nextTick(async _ => {
        if (!this.addNewTagAsDropdown) {
          await this.$refs.saveTagInput.$refs.inputRef.focus()
        }
      })
    },
    handleInputEvent (event, type) {
      if (type === 'onEnter') {
        this.handleInputConfirm()
      }

      if (type === 'onSelect') {
        this.handleInputConfirm()
        this.handleNewTagOptions()
      }

      if (type === 'suggestionSelect') {
        this.$nextTick(_ => {
          this.handleInputConfirm({ type: 'suggestionSelect' })
        })
      }
    },
    handleInputTag (event, indx, action) {
      let updatedTags = this.$utils.clone(this.tags)
      const modifyTagIsDisabled = (this.$currentUser.hasGroupUserCreateLock() && [this.accessorComponents.templateSets.mediaMenu, this.accessorComponents.templateSets].indexOf(this.accessorComponent) >= 0)
      const selectedTagItem = this.$utils.clone(this.selectedTagItem)

      if (action === 'create') {
        const inputValue = event.trim()
        const isConfigTag = inputValue.split(':').length > 1

        /**
         * Validate tag chars
         * - Normal tag should not exceed 32 chars
         * - Config tag should not exceed 128 chars
         */
        if ((!isConfigTag && inputValue.length >= this.normalTagMaxCharLength) || (isConfigTag && inputValue.length >= this.configTagMaxCharLength)) {
          this.inputValue = this.inputTagValueBeforeChanged
          return
        }

        this.inputTagValueBeforeChanged = inputValue

        if (inputValue) {
          const existFromList = updatedTags.findIndex((currentTag) => { return currentTag.value === inputValue }) >= 0

          if (!existFromList) {
            updatedTags.push(inputValue)
            updatedTags = this.filterTagsItemForUI(updatedTags)
            if (!modifyTagIsDisabled) {
              selectedTagItem.index = null
              selectedTagItem.newVal = inputValue
              selectedTagItem.origVal = inputValue
              selectedTagItem.createNewTag = true
              this.selectedTagItem = selectedTagItem
            }
          }
        }
      } else {
        if (!modifyTagIsDisabled) {
          const isConfigTag = updatedTags[indx].value.split(':').length > 1

          /**
            * Validate tag chars
            * - Normal tag should not exceed 32 chars
            * - Config tag should not exceed 128 chars
            */
          if ((!isConfigTag && updatedTags[indx].value.length >= this.normalTagMaxCharLength) || (isConfigTag && updatedTags[indx].value.length >= this.configTagMaxCharLength)) {
            updatedTags[indx].value = this.inputTagValueBeforeChanged
          }

          selectedTagItem.createNewTag = false
          selectedTagItem.newVal = updatedTags[indx].value
          this.selectedTagItem = selectedTagItem
          this.inputTagValueBeforeChanged = updatedTags[indx].value
        }
      }
    },
    handleInputConfirm (params = {}) {
      let isTagsUpdated = false

      if (this.tags.length && typeof this.tags[0] === 'string') {
        this.tags = this.filterTagsItemForUI(this.tags)
      }

      const selectedTagItem = this.$utils.clone(this.selectedTagItem)

      // Edit tag
      if (params && params.type === 'edit') {
        const newTag = selectedTagItem.index !== null && this.tags[selectedTagItem.index].value
        const origTag = selectedTagItem.origVal

        if (!selectedTagItem.createNewTag && newTag !== origTag) {
          isTagsUpdated = true
        }
      } else { // New tag
        const inputValue = this.inputValue.trim()
        if (inputValue) {
          // A user with a user tag rights should not be able to add new tag
          const isAddingNewTagDisabled = this.$currentUser.getUserTags().length && !this.$currentUser.getUserTags().includes(inputValue)
          const currentTags = this.tags
          const existFromList = currentTags.findIndex((currentTag) => { return currentTag.value === inputValue }) >= 0

          if (!isAddingNewTagDisabled && !existFromList) {
            currentTags.push(inputValue)
            this.tags = this.filterTagsItemForUI(currentTags)
            isTagsUpdated = true
          }
        }

        this.isNewInputTagVisible = false
        this.inputValue = ''
        this.handleForceToHideNewButton()
      }

      // Process New Tag
      if (isTagsUpdated) {
        // Remove empty tags
        this.tags = this.$utils.clone(this.tags).filter((tag) => { return ((typeof tag === 'object') && tag.value && tag.value.trim().length >= 1) || ((typeof tag === 'string') && tag.trim().length >= 1) })

        // Send data to parent component and vuex store
        this.emitEvent('TAGS_UPDATED', {
          tags: this.filterTagsItemForBackend(this.tags)
        })
        this.$store.dispatch('updatedTags', {
          component: this.accessorComponent,
          lastAction: selectedTagItem.createNewTag ? 'created' : 'edited',
          tagNewVal: selectedTagItem.newVal,
          tagOldVal: selectedTagItem.origVal,
          tags: this.filterTagsItemForBackend(this.tags)
        })
      }

      this.resetTagsSelection()
    },
    filterTagsItemForUI (tagsSrc) {
      const tags = []

      tagsSrc.forEach((tag) => {
        const newTag = this.$utils.formatPageTagWithColors(tag, this.tagsSummary, this.storeOnLoadTagsFromSlider)

        if (this.accessorComponent === 'ledPage') {
          const tagsSliderEl = $('.ledPageMediaTags').find('.el-tag-ledPageMediaTags')
          tagsSliderEl.each((indx, el) => {
            const tagValue = $(el).find('.tag-val span').text()

            if (tagValue === newTag.value) {
              const elBackgroundColor = ($(el).find('.background-color').css('background-color').replace('rgb', 'rgba')).replace(')', ', 0.6)')
              newTag.color = elBackgroundColor
            }
          })
        }

        tags.push(newTag)
      })

      const filterTagsParams = { tags, showLabel: false }

      if ([this.accessorComponents.playerLEDTagsMenuItem, this.accessorComponents.monitoringLEDTagsInfo].indexOf(this.accessorComponent) >= 0) {
        filterTagsParams.ledDimensionTag = true
        filterTagsParams.showLabel = true
        filterTagsParams.removeLEDPrefixForLabel = true
        filterTagsParams.disabledEditActionabel = true
        filterTagsParams.disabledDeleteActionabel = true
        filterTagsParams.setNormalColors = true
      }

      const resTags = this.$utils.filterTagOptionsForUI(filterTagsParams)

      return resTags
    },
    filterTagsItemForBackend (tagsSrc) {
      const tags = []

      tagsSrc.forEach((tag, indx) => {
        tags.push(tag.value)
      })

      return tags
    },
    resetTagsSelection () {
      this.selectedTagItem = {
        index: null,
        origVal: null,
        newVal: null,
        createNewTag: false
      }
    },
    handleTagItemClick (tag, indx) {
      if (!this.enableEditTags) return

      if (this.disabledEditTagItems.indexOf(tag.value) >= 0 || this.disabledEditTagItems.indexOf('_allTags') >= 0) {
        return
      }

      this.selectedTagItem = {
        index: indx,
        origVal: this.$utils.clone(this.tags)[indx].value,
        newVal: this.$utils.clone(this.tags)[indx].value,
        createNewTag: false
      }
      this.$nextTick(_ => {
        this.$refs[`idTagInput-${indx}`][0].focus()
        this.$refs[`idTagInput-${indx}`][0].select()
      })
    },
    /**
     * Custom blur to avoid conflict between onBlur event and when selecting suggetion item
     */
    handleNewTagInputElBlur () {
      $(window).on('click', (event) => {
        const isNewTagInputVisible = $('.new-tag-wrapper').find('.el-input').length
        const targetElClick = $(event.target)

        if (isNewTagInputVisible) {
          const isNotInputTag = !$(event.target).hasClass('el-input__inner')
          const isNotShowInputTagBtn = !targetElClick.hasClass('new-tagb-btn')

          if (isNotInputTag && isNotShowInputTagBtn) {
            this.handleInputConfirm()
          }
        }
      })
    },
    handleNewTagOptions () {
      const updatedTags = this.$utils.clone(this.tags)
      const tagsSummary = this.$utils.clone(this.tagsSummary)
      const newTagsOptions = []

      tagsSummary.forEach((item) => {
        const existFromList = updatedTags.findIndex((currentTag) => { return currentTag.value === item.value }) >= 0

        if (this.accessorComponent === this.accessorComponents.playerLEDTagsMenuItem) {
          item.label = item.showLabel
        }

        if (item.value && (item.value !== '_toSeeAllData' && !existFromList)) {
          newTagsOptions.push(item)
        }
      })

      this.newTagOptions = newTagsOptions
    },
    onEnter (event) {
      if (event.target.id === 'tags-edit-input') {
        event.target.blur()
      } else if (event.target.id === 'tags-add-input') {
        this.handleInputEvent(event, 'onEnter')
      }
    }
  },
  mounted () {
    this.setDefaultData(this.tags, 'onMount')
  }
}
